<template>
  <div class="demo__flex demo__flex-column demo__margin-top--16 demo__gap--24">
    <template v-if="verifyStatus === 'rejected'">
      <p
        class="demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--0"
      >
        {{ $t("VerifyModal.step3.rejected.text1_1") }}
      </p>
      <a-button
        class="demo__button demo__button--gray demo__width-full"
        @click="changeStepTo1"
        >{{ $t("VerifyModal.step3.rejected.text1_2") }}</a-button
      >
    </template>
    <template v-else>
      <p
        class="demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--0"
      >
        {{ $t("VerifyModal.step3.processing.text1_1") }}{{ user.email
        }}{{ $t("VerifyModal.step3.processing.text1_2") }}
      </p>
      <p
        class="demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--0"
      >
        {{ $t("VerifyModal.step3.processing.text2") }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
    verifyStatus: {
      required: false,
      type: String,
    },
  },
  methods: {
    changeStepTo1() {
      this.$root.$emit("changeVerifyStep", 1);
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.$accessModule("VerifyModal_step3", this);
  },
};
</script>
